import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AuditFilters } from "@/types/audit";
import { Filter, X } from "lucide-react";

interface AuditFiltersProps {
  onFiltersChange: (filters: AuditFilters) => void;
}

const ACTION_CATEGORIES = [
  { value: 'company', label: 'Empresas' },
  { value: 'user', label: 'Usuários' },
  { value: 'plan', label: 'Planos' },
  { value: 'billing', label: 'Faturamento' },
  { value: 'permission', label: 'Permissões' },
];

export function AuditFiltersComponent({ onFiltersChange }: AuditFiltersProps) {
  const [filters, setFilters] = useState<AuditFilters>({});

  const handleFilterChange = (key: keyof AuditFilters, value: any) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const clearFilters = () => {
    setFilters({});
    onFiltersChange({});
  };

  const hasActiveFilters = Object.keys(filters).some(key => filters[key as keyof AuditFilters]);

  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Filter className="h-5 w-5" />
          <h3 className="text-lg font-semibold">Filtros</h3>
        </div>
        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={clearFilters}>
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <div className="space-y-2">
          <Label>Data Inicial</Label>
          <Input
            type="date"
            value={filters.startDate ? filters.startDate.toISOString().split('T')[0] : ''}
            onChange={(e) => handleFilterChange('startDate', e.target.value ? new Date(e.target.value) : undefined)}
          />
        </div>

        <div className="space-y-2">
          <Label>Data Final</Label>
          <Input
            type="date"
            value={filters.endDate ? filters.endDate.toISOString().split('T')[0] : ''}
            onChange={(e) => handleFilterChange('endDate', e.target.value ? new Date(e.target.value) : undefined)}
          />
        </div>

        <div className="space-y-2">
          <Label>Categoria</Label>
          <Select
            value={filters.entityType || 'all'}
            onValueChange={(value) => handleFilterChange('entityType', value === 'all' ? undefined : value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Todas" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Todas</SelectItem>
              {ACTION_CATEGORIES.map(cat => (
                <SelectItem key={cat.value} value={cat.value}>
                  {cat.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label>Buscar</Label>
          <Input
            placeholder="ID, usuário, empresa..."
            value={filters.searchTerm || ''}
            onChange={(e) => handleFilterChange('searchTerm', e.target.value || undefined)}
          />
        </div>
      </div>
    </Card>
  );
}
